// extracted by mini-css-extract-plugin
module.exports = {"products":"ProductList_products__3dOxC"};